import { render, staticRenderFns } from "./HistoricScheme.vue?vue&type=template&id=5163869a&scoped=true&"
import script from "./HistoricScheme.vue?vue&type=script&lang=ts&"
export * from "./HistoricScheme.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricScheme.vue?vue&type=style&index=0&id=5163869a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5163869a",
  null
  
)

export default component.exports